export class File360Component {

    private _title: string = "";

    public get title() {
        return this._title;
    }

    public set title(title: string) {
        this._title = title;
    }

    public constructor(title: string) {
        this.title = title;
    }
}